import * as React from "react";
import _ from "lodash";
import moment from "moment";
import { Icon } from "antd";
import { Publication } from "../../../../Analytics";

import "./style.scss";

export interface FlyerThumbnailProps {
  publication: Publication;
  publicationIds: number[];
  publicationGroup: string;
  publications: Publication[];
}
export interface QuerySelectorInternalActions {
  togglePublication: (
    publication: Publication[],
    selected_publication_id: [number]
  ) => void;
}

export const FlyerThumbnail = (
  props: FlyerThumbnailProps & QuerySelectorInternalActions
) => {
  let { publicationGroup, publication, publicationIds } = props;
  let selected = [] as any;
  if (publicationIds)
    selected = publicationIds
      ? publicationIds.find((i: any) => i == publication.flyer_run_id)
      : 0;

  let borderStyle = selected ? "solid 3px #466E9F" : "solid 3px rgba(0,0,0,0)";
  let availableFrom = moment(publication.available_from).format("MMM D YYYY");
  // Ideally this would be done in the backend - but the table itself seems to be returning a string value
  // for start and end dates
  let availableTo = moment(publication.available_to).format("MMM D YYYY"); //.subtract(1, "days")

  return (
    <div
      className="flyer-thumbnail-wrapper"
      style={{ position: "relative", display: "inline-block" }}
    >
      <div
        className="flyer-thumbnail-check"
        style={{ display: `${selected ? "block" : "none"}` }}
      >
        <Icon type="check" style={{ padding: 4, color: "white" }} />
      </div>
      <div
        className={`flyer-thumbnail ${publicationGroup ? "flyer-publicationType" : ""}`}
        onClick={() => {
          if (publicationGroup) {
            props.togglePublication(props.publications, selected);
          } else {
            props.togglePublication([publication], selected);
          }
        }}
        style={{ border: borderStyle }}
      >
        <img src={publication.l_thumbnail} className="flyer-thumbnail-img" />
        <div
          className="flyer-run-name"
          style={{ fontSize: 14, fontWeight: "bold", marginTop: 154 }}
        >
          {publicationGroup ? publicationGroup : publication.flyer_run_name}
        </div>
        {!publicationGroup ? (
          <div>{`Valid ${availableFrom} - ${availableTo}`}</div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./client/modules/common/components/QuerySelector/FlyerThumbnail/index.tsx